import React, { useEffect, useRef } from 'react';
import { useInView } from 'react-intersection-observer';
import { motion, useAnimation } from 'framer-motion';

const RightScroll = ({ children }) => {
  const [ref, inView] = useInView({ triggerOnce: true });
  const controls = useAnimation();
  const revealRef = useRef();

  useEffect(() => {
    if (inView) {
      controls.start('visible');
    }
  }, [controls, inView]);

  return (
    <div ref={ref} className="">
      <motion.div
        ref={revealRef}
        initial="hidden"
        animate={controls}
        variants={{
          visible: { opacity: 1, x: 0 , rotate: 0},
          hidden: { opacity: 0, x: 400, rotate:180 },
        }}
        transition={{ duration: 0.6 }}
        className=""
      >
        {children}
      </motion.div>
    </div>
  );
};

export default RightScroll;
